export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/language/state.js